const toggleMenu = () => {
    $('.collapse').fadeToggle();
    $('.collapse__wrapper').toggleClass('active');
}

$(document).on('click', '.navbar-toggler', function() {
    toggleMenu();
    $(this).toggleClass('collapsed active')
    $('.header__toggler-wrapper').toggleClass('active')
});
